import React from "react";
import {connect} from "react-redux";
import TreeNode from "./TreeNode";
import {RiNodeTree} from "react-icons/ri";

const NodeTree = ({data}) => {

    const _minWidth = 290

    const _width = 'auto'

    const _minHeight = window.innerHeight - 150
    const _maxHeight = _minHeight
    const _height = _minHeight

    const _root = data.find(it => it.path === "0.0.0.0" && it.linkrole === 2);
    const _clients = data.filter(it => it.linkrole === 1) || []

    return (
        <div>
            <div className="list listHeader" style={{
                width: _width,
                minWidth: _minWidth,
            }}>
                <RiNodeTree/>&nbsp;Nodes
            </div>
            <div className="list listBody" style={{
                width: _width,

                minWidth: _minWidth,

                height: _height,
                minHeight: _minHeight,
                maxHeight: _maxHeight,
                overflowY: 'auto',
            }}>
                {_clients.map((cit) => {
                    return <TreeNode node={cit} others={_clients} level={0}/>
                })}
                <TreeNode node={_root} others={data} level={0}/>
            </div>
        </div>
    )

}

function mapStateToProps(state, other) {
    return {data: state.bidib.data.node.filter(it => it.type === "node" && it.available && it.connected)}
}

export default connect(mapStateToProps)(NodeTree)
